import user from 'lib/user';
import { redirectUrl } from 'lib/base';
import { appClient } from '@/lib';
// import bag from 'widgets/functions/gift/bag'

const actions = {
  // 跳转到支付
  showPayPopup(data) {
    user.showNoMoney();
  },
  redirectPage(data) {
    // window.open(data.url);

    console.log('redirectPage-18', data, data.type);
    if (data.type === 'memeClient') {
      if (data.roomType === 'party') {
        appClient.redirectParty(data.roomId);
        appClient.closeWindow();
      }
      return;
    }
    redirectUrl(data.url, true);
  },
  // 刷新背包
  refreshBag() {
    user.loadUserInfo();
    try {
      // MM.live.bag.refresh();
    } catch (e) {
      // bag.init()
    }
  },
  // 刷新用户信息，包含顶部的余额显示
  refreshUserInfo() {
    user.loadUserInfo();
  },
  redirectLogin() {
    user.popupLogin();
  },

  addPriChat(data) {
    if (data.userId) {
      if (data.setChatTop) {
        // 将私聊弹窗置顶
        const $bar = document.getElementById('j_fixedbar');
        if ($bar) {
          $bar.style.zIndex = 100000;
        }
      }
      window.ImApp.addChat(data.userId);
    }
  },
  uploadStarCover() {
    try {
      MM.live.star.cover.show();
    } catch (e) {}
  },
};

export default actions;
